const buildRoutes = (prefix = '') => {
    const p = prefix ? `${prefix}/` : ''
    return {
        getNotifications:       { method: 'get',    url: `${p}notifications` },
        markAsRead:             { method: 'put',    url: `${p}notifications/{id}/read` },
        markAllAsRead:          { method: 'put',    url: `${p}notifications/read-all` },
        getUnreadCount:         { method: 'get',    url: `${p}notifications/unread-count` },
    }
}

export const notification = buildRoutes()
export const notificationTeacher = buildRoutes('teacher')

export default notification
